import {
  isLDDPurchaseCondition,
  isWarehousePurchaseCondition,
  PurchaseCondition
} from '@/models/purchase-condition/purchase-condition';
import { UntypedPurchaseCondition } from '@/models/purchase-condition/untyped-purchase-condition';
import { getFormattedDate } from './date-formater';
import I18n from '@/plugins/i18n';
import { getBillingUnitLabel } from '@/models/purchase-condition/billing-unit';

const percentageFields = ['cgvDiscount', 'otherCgvDiscount', 'cpvDiscount'];

export function accessValue(purchaseCondition: UntypedPurchaseCondition, fieldPath: string): string {
  const fieldPathKeys = fieldPath.replace(/\[(\d)\]/, '.$1').split('.');
  let value = fieldPathKeys.reduce((obj: any, key) => obj[key], purchaseCondition);
  if (percentageFields.includes(fieldPath)) {
    value = (value * 100).toFixed(0);
  }
  return value;
}

export function getControlReportFieldTranslateKey(field: string): string {
  const fieldPath = field.replace(/\[\d\]/, '');
  return `headers.purchaseCondition.${fieldPath}`;
}

export function transformPurchaseConditionToCsvLine(purchaseCondition: PurchaseCondition): string {
  const {
    superSupplierCode,
    superSupplierCorpName,
    legalSupplierCode,
    supplierCode,
    supplierCorpName,
    ean,
    ref,
    supplierRef,
    billingUnit,
    currency,
    ecoParts,
    incoTerm,
    pcbPackaging,
    francoAmount,
    francoUnit,
    grossPrice,
    cgvDiscount,
    otherCgvDiscount,
    cpvDiscount,
    netPrice,
    insertionDate
  } = purchaseCondition;

  const { deaFourniture, d3eElec, d3eLight, pmcb } = ecoParts ?? {};

  const designation = purchaseCondition.designation.replace(/"/g, '""');
  const beginDate = getFormattedDate(purchaseCondition.beginDate, '/');
  const circuitTranslation = I18n.t(`headers.circuits.${purchaseCondition.circuit}`);
  const billingUnitLabel = getBillingUnitLabel(billingUnit);

  let multiplePCB: number | '' = '';
  let logisticDiscount: number | '' = '';
  let transportPrice: number | '' = '';
  let netPriceWithoutTransportPrice = netPrice;
  let netPriceWithTransportPrice: number | '' = '';

  if (isWarehousePurchaseCondition(purchaseCondition)) {
    multiplePCB = purchaseCondition.multiplePCB;
    logisticDiscount = purchaseCondition.logisticDiscount ?? '';
  }

  if (isLDDPurchaseCondition(purchaseCondition)) {
    transportPrice = purchaseCondition.transportPrice;
    netPriceWithoutTransportPrice = purchaseCondition.netPriceWithoutTransportPrice;
    netPriceWithTransportPrice = netPrice;
  }

  const csvLine = `${superSupplierCode};${superSupplierCorpName};${legalSupplierCode};${supplierCode};"${supplierCorpName}";${ean};${supplierRef};${ref};"${designation}";${beginDate};${billingUnitLabel};${currency};${d3eLight};${d3eElec};${deaFourniture};${pmcb};${circuitTranslation};${incoTerm};${pcbPackaging};${multiplePCB};${francoAmount};${francoUnit};${grossPrice};${cgvDiscount};${otherCgvDiscount};${cpvDiscount};${logisticDiscount};${netPriceWithoutTransportPrice};${transportPrice};${netPriceWithTransportPrice};${insertionDate}`;

  return csvLine.replace(/(null|undefined)/g, '');
}
